var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "termine",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: currentColor;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: currentColor;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M19,3H3A2,2,0,0,0,1,5V18a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M5,13a1,1,0,1,0-1-1A1,1,0,0,0,5,13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-2",
    d: "M9,13a1,1,0,1,0-1-1A1,1,0,0,0,9,13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M13,13a1,1,0,1,0-1-1A1,1,0,0,0,13,13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-2",
    d: "M17,13a1,1,0,1,0-1-1A1,1,0,0,0,17,13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M5,16a1,1,0,1,0-1-1A1,1,0,0,0,5,16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-2",
    d: "M9,16a1,1,0,1,0-1-1A1,1,0,0,0,9,16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M13,16a1,1,0,1,0-1-1A1,1,0,0,0,13,16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M17,16a1,1,0,1,0-1-1A1,1,0,0,0,17,16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "M21,7H1V8H21Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M8,1A1,1,0,0,0,6,1V4A1,1,0,0,0,8,4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-2",
    d: "M16,1a1,1,0,0,0-2,0V4a1,1,0,0,0,2,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.ddc25b6635fd6cadbe4804859b75e731.svg";
export { ForwardRef as ReactComponent };